import { useEffect, useState } from "react";
import { BookingForm } from "../components/booking-section/booking-form";
import { SessionCarousel } from "../components/booking-section/session-carousel";
import { ToastContainer } from "react-toastify";

const Booking = () => {
  const [selectedSession, setSelectedSession] = useState<string | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="pt-20">
      <ToastContainer />
      {selectedSession ? (
        <BookingForm
          onBack={() => setSelectedSession(null)}
          selectedPackageId={selectedSession} // Pass the selected package ID
        />
      ) : (
        <SessionCarousel onSessionSelect={setSelectedSession} />
      )}
    </main>
  );
};

export default Booking;
